import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InputFL } from "Components/Inputs";
import { SigningEmailProps, useSigningEmailEffect } from "./SigningCommon";


interface AdfsFormModel {
   email: string,
}

const AdfsFormSchema: yup.SchemaOf<AdfsFormModel> = yup.object({
   email: yup.string()
      .required("Email is required")
      .email("Email is not valid")
      .defined(),
}).defined();



export interface AdfsFormProps extends SigningEmailProps {
   isActive: boolean;
   adfsProvider: LSCommon.Context.AdfsProvider | undefined,   
}

export const AdfsForm: React.FC<AdfsFormProps> = function ({ isActive, adfsProvider, ...signingEmailProps }) {
   const formMethods = useForm<AdfsFormModel>({
      defaultValues: {
         email: signingEmailProps.email,
      },
      resolver: yupResolver(AdfsFormSchema),      
      mode: "onTouched"
   });

   useSigningEmailEffect(signingEmailProps, formMethods, "email");

   const onLoginClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (adfsProvider) {
         LSHelper.Sso.popupSsoLoginCommon(LSHelper.Sso.addParamToUrl(adfsProvider.Url!, "SAMLRequest=" + adfsProvider.SAMLRequest!), false, 1024, 450);
      }
   }

   useEffect(() => {
      if (isActive) {
         setTimeout(function () {
            formMethods.setFocus("email");
         }, 500);
      }
   }, [isActive])

   return (
      <div className="signing-mode-inner">
         <div className="signing-header">
            Log in
         </div>
         <div className="signing-caption">
            You are now required to log in at {adfsProvider?.Name || "Organization"}
         </div>
         <div className="signing-adfs-form">            
            <InputFL control={formMethods.control} name="email" placeholder="Email" className="signing-adfs-input" autoComplete="off" />
            <a href="#" className="btn btn-primary btn-md signing-adfs-cta btn--fluid" onClick={onLoginClick}>Log in at {adfsProvider?.Name || "Organization"}</a>
         </div>
      </div>
   )
}